import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getAssetLink } from '../../helpers/get-asset-link'

const HolidayTipsItem = ({ name, image, position, setMember }) => {
  const { t } = useTranslation(['holiday-tips'])
  return (
    <div className="holiday-tips__item">
      <img
        src={getAssetLink({ path: 'chitown-avatar/avatar', file: image })}
        alt={t('holiday-tips:shared.memberImageAlt')}
        className="holiday-tips__item-image"
        onError={(e) => {
          e.target.src = getAssetLink({ path: 'chitown-avatar/avatar', file: 'default.png' })
        }}
      />
      <div className="holiday-tips__item-content">
        <span className="holiday-tips__item-name">{name}</span>
        <span className="holiday-tips__item-position">{position}</span>
        <button
          className="holiday-tips__item-button"
          onClick={() => setMember({ name, image, position })}
        >
          {t('holiday-tips:item.sendTipButton')}
        </button>
      </div>
    </div>
  )
}

HolidayTipsItem.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  setMember: PropTypes.func.isRequired,
}

export default HolidayTipsItem
